import {
    SET_STATISTICS_STATUS,
    RESET_STATISTICS_LIST_STATUS,
    RESET_PROCESS_ERROR,
    FETCH_STATISTICS_LIST,
    FAIL_FETCH_STATISTICS_LIST,
    SET_STATISTICS_LIST,
    GET_STATISTICS_EXCEL,
    FAIL_GET_STATISTICS_EXCEL,
    SUCCESS_GET_STATISTICS_EXCEL,
} from "../actions";
import {doDlFiles} from '../common/utils/files';

const initialState = {
    isFetching : false,
    error : false,
    isProcessError : false,
    currentFormValues : {},
    outputData : [],
    outputColumn : [],
    numberColumns :[],
    conditions:[],
};
export default function statisticsListSettings(state = initialState, action) {
    let ret = Object.assign({}, state, {});
    switch (action.type) {
        case FETCH_STATISTICS_LIST:
            ret.isFetching = true;
            return ret;
        case FAIL_FETCH_STATISTICS_LIST:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SET_STATISTICS_LIST:
            ret.outputData = action.payload.data.data;
            ret.outputColumn = action.payload.data.columns;
            ret.numberColumns = action.payload.data.numberColumns;
            ret.conditions = action.payload.data.conditions;
            ret.isFetching = false;
            return ret;
        case SET_STATISTICS_STATUS:
            return Object.assign({}, state, action.payload);
        case GET_STATISTICS_EXCEL:
            ret.isFetching = true;
            return ret;
        case FAIL_GET_STATISTICS_EXCEL:
            ret.isFetching = false;
            ret.error = action.payload.err;
            ret.isProcessError = true;
            return ret;
        case SUCCESS_GET_STATISTICS_EXCEL:
            const filepath = action.payload.data.path;
            //window.open(filepath, '_blank');
            doDlFiles(filepath,'test.xlsx');
            ret.isFetching = false;
            return ret;
        case RESET_STATISTICS_LIST_STATUS:
            Object.keys(initialState).forEach((keys)=>{
                ret[keys] = initialState[keys];
            });
            return ret;
        case RESET_PROCESS_ERROR:
            ret.isProcessError = false;
            return ret;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/statistics-list.js